module.exports = __webpack_public_path__ + "img/P569205803.50ff08af.jpg";